import type { CompanyReportSection } from '@/pages/CompanyReport/useSection';
import { Button } from '@simplywallst/ui-core';
import { useVisibleSectionsContext } from '@/pages/CompanyReport/components/VisibleSectionsContextProvider';
import { useCompanyReportPageUrl } from '@/pages/CompanyReport/hooks/useCompanyReportPageUrl';

interface Props {
  section: CompanyReportSection;
  text: string;
}

export const SnowflakeCellLink = ({ section, text }: Props) => {
  const { loadSection } = useVisibleSectionsContext();
  const companyUrl = useCompanyReportPageUrl();

  return (
    <Button
      as="a"
      styleType="softLink"
      href={`${companyUrl}/${section}`}
      onClick={(e) => {
        loadSection(section);
        e.preventDefault();
      }}
    >
      {text}
    </Button>
  );
};
